import React, { useContext } from 'react';
import {
  Box,
} from '@mui/material';


import { TabInfoContext } from '../../contexts/tab-info.context';
import { GlobalContext } from '../../contexts/global.context';

import './pdf-panel.styles.scss';


export default function PDFPanel() {
  const tabInfoContextObj = useContext(TabInfoContext);
  const { pdfPanelInfo } = tabInfoContextObj;
  const { display, selectedSubTab } = useContext(GlobalContext);

  const pdfs = pdfPanelInfo.filter(pdfObj => {
    let showTab = true;

    if (pdfObj.onlyShowIfChart && display !== 'chart') {
      showTab = false;
    }

    if (pdfObj.onlyShowIfMap && display !== 'map') {
      showTab = false;
    }

    if (Array.isArray(pdfObj.showIfSubTab) && !pdfObj.showIfSubTab.includes(selectedSubTab)) {
      showTab = false;
    }
    
    return showTab;
  });

  if (pdfs.length === 0) {
    return '';
  } else {
    return (
      <Box className='pdf-panel'>
        {pdfs.map(({ pdfFilename }, i) =>
          <embed key={i} src={`${process.env.PUBLIC_URL}/${pdfFilename}`} width="100%" style={{ maxWidth: '1000px', aspectRatio: '1/1', borderBottom: '3px solid rgb(42,42,46)' }} />
        )}
      </Box>
    );
  }
}